import { render, staticRenderFns } from "./materialsApplyEdit.vue?vue&type=template&id=988b1aaa&scoped=true&"
import script from "./materialsApplyEdit.vue?vue&type=script&lang=js&"
export * from "./materialsApplyEdit.vue?vue&type=script&lang=js&"
import style0 from "./materialsApplyEdit.vue?vue&type=style&index=0&id=988b1aaa&prod&lang=scss&scoped=true&"
import style1 from "./materialsApplyEdit.vue?vue&type=style&index=1&id=988b1aaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b1aaa",
  null
  
)

export default component.exports